import type { TSupportedLocale } from "libs/i18n/src/lib/i18n.locales";
import { setRegionCookie } from "libs/i18n/src/lib/region-cookie";
import { withLocalePrefix } from "apps/website/i18n/paths";

type TLocationSuffix = {
  search: string;
  hash: string;
};

/** `pathname` must be unprefixed, as returned by the locale-aware `usePathname`. */
export const getLocaleHref = (
  pathname: string,
  locale: TSupportedLocale,
  { search, hash }: TLocationSuffix,
): string => `${withLocalePrefix(pathname, locale)}${search}${hash}`;

/**
 * A full page load rather than a client-side transition, so the request can reach
 * the other region's deployment and the switch is kept in browser history.
 * The cookie is set first so it is sent with that request.
 */
export const navigateToLocale = (pathname: string, locale: TSupportedLocale): void => {
  setRegionCookie(locale);
  window.location.assign(getLocaleHref(pathname, locale, window.location));
};
